export default __webpack_public_path__ + "static/media/wayfarer.0bb2caee.png";